<template>
  <div class="center-wrapper">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'CenterWrapper',
};
</script>

<style scoped>
.center-wrapper {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 50px;
  overflow: hidden;
}

@media (max-width: 768px) {
  .center-wrapper {
    padding: 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CenterWrapper.vue